import { useReducer } from 'react';
import { IResponse, IState } from '../response';
import useSplunkLogger from '../hooks/useSplunkLogger';
import { splunk_message } from './../splunk_constant';


enum ActionType {
  Success = 'success',
  Loading = 'loading',
  Error = 'error',
}

const initialState: IState = { data: null, error: '', loading: false };

const reducer = (state: any, action: any): IState => {
  switch (action.type) {
    case ActionType.Success:
      return {
        ...state,
        data: action.payload,
      };
    case ActionType.Loading:
      return {
        ...state,
        loading: action.payload,
      };
    case ActionType.Error:
      return {
        ...state,
        error: action.payload,
      };
    // for any other type, return the current state
    default:
      return state;
  }
};

const useApi = (apiFunc: any): IResponse => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { splunkLogger } = useSplunkLogger();
  const request = async (args?: any) => {
    dispatch({ type: ActionType.Loading, payload: true });
    try {
      const result = await (args ? apiFunc(...args) : apiFunc());
      dispatch({ type: ActionType.Success, payload: result.data });
      splunkLogger({
        logType: 'info',
        data: splunk_message.SUCCESS.USE_API_SUCCESS
      })
    } catch (err: any) {
      splunkLogger({
        logType: 'error',
        data: { ...splunk_message.ERROR.USE_API_ERROR, err }
      })
      // TODO: Log the errors as needed
      dispatch({ type: ActionType.Error, payload: err.message || 'Unexpected error!' });
    } finally {
      dispatch({ type: ActionType.Loading, payload: false });
    }
  };

  return {
    ...state,
    request,
  };
};

export default useApi;
